type GetVCardTemplate = {
  name: string;
  job: string;
  company: string;
  image: string;
  phone: string;
  address: string;
  email: string;
  website: string;
};
export const getVCardTemplate = ({
  name,
  job,
  company,
  phone,
  image,
  address,
  email,
  website
}: GetVCardTemplate) =>
  `
      BEGIN:VCARD
      VERSION:3.0
      N:${name ?? ''}
      FN:${name ?? ''}
      TITLE:${job ?? ''}
      ORG:${company ?? ''}
      PHOTO;TYPE=image/jpeg;ENCODING=b:${image}
      TEL;TYPE=WORK:${phone ?? ''}
      ADR;TYPE=WORK:${address ?? ''}
      EMAIL:${email ?? ''}
      URL;TYPE=WEBSITE:${website ?? ''}
      END:VCARD
    `.replace(/^\s+/gm, '');
